/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/services/app.contact-button.service.ts.
 */
import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

/**
 * Zweck: Beschreibt class ContactButtonService und ihren Daten- oder Funktionsvertrag.
 */
@Injectable({providedIn: 'root'})
export class ContactButtonService {
  visible = new BehaviorSubject(true);

/**
 * Beschreibt Methode hide und ihren Rückgabevertrag.
 */
  hide() {
    this.visible.next(false);
  }

/**
 * Beschreibt Methode show und ihren Rückgabevertrag.
 */
  show() {
    this.visible.next(true);
  }
}
